<div class="selected_vehicles" *ngIf="selectedItems.length > 0">
  <div class="d-flex align-items-center">
    <h2 class="font-weight-bold mb-0 me-3">{{selectedItems.length}} {{selectedItems.length>1 ? selectedFor :
      selectedFor.slice(0, -1)}} Selected</h2>
    <button (click)="exportResults()" [disabled]="isExporting" mat-flat-button color="primary" class="ms-3">
      {{isExporting?'Exporting':'Export'}} {{selectedFor}}{{isExporting?'...' : ''}}
    </button>
  </div>
</div>